"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const ConfigModal_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Modals/ConfigModal.vue"));
const TabsSet_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/TabsSet.vue"));
const Tab_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Tab.vue"));
const GroupIcon_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Entities/GroupIcon.vue"));
const SubgroupIcon_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Entities/SubgroupIcon.vue"));
const SampleIcon_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Entities/SampleIcon.vue"));
const CellIcon_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Entities/CellIcon.vue"));
const ZoomIcon_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Entities/ZoomIcon.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
let VizActions = class VizActions extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.focus = [
            { id: 'zoom', sh: (0, trans_1.trans)('heatmap.viz.modes.zoom_sh'), long: (0, trans_1.trans)('heatmap.viz.modes.zoom') },
            { id: 'groups', sh: (0, trans_1.trans)('heatmap.viz.modes.group_sh'), long: (0, trans_1.trans)('heatmap.viz.modes.group') },
            { id: 'subgroups', sh: (0, trans_1.trans)('heatmap.viz.modes.subgr_sh'), long: (0, trans_1.trans)('heatmap.viz.modes.subgr') },
            { id: 'samples', sh: (0, trans_1.trans)('heatmap.viz.modes.sampl_sh'), long: (0, trans_1.trans)('heatmap.viz.modes.sampl') },
            { id: 'cells', sh: (0, trans_1.trans)('heatmap.viz.modes.cells_sh'), long: (0, trans_1.trans)('heatmap.viz.modes.cells') }
        ];
        this.triggerTheModal = false;
    }
    isEnabledFocus(id) {
        var _a, _b;
        if (id === 'groups' && (((_a = this.heatmap.root) === null || _a === void 0 ? void 0 : _a.maxLevel()) || 0) < 1) {
            return false;
        }
        else if (id === 'subgroups' && (((_b = this.heatmap.root) === null || _b === void 0 ? void 0 : _b.maxLevel()) || 0) < 2) {
            return false;
        }
        return true;
    }
    saveConfig() {
        this.triggerTheModal = true;
    }
    closeModal() {
        this.triggerTheModal = false;
    }
    async downloadHeatmap() {
        await this.heatmap.download();
    }
    toggleMap() {
        this.$emit('togglemap');
    }
    async goFullscreen() {
        /*         await this.heatmap.fullscreen();
                const modal = <any> this.$refs.htmpfullscreen;
                modal.open();
                console.log("from vizac");
                console.log(this.heatmap.fs_svg) */
        this.$emit('toggleFS');
    }
    closeFullScreenModal() {
        const modal = this.$refs.htmpfullscreen;
        modal.close();
    }
    switchFocusTab(f) {
        this.heatmap.selectedFocus = f.id;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], VizActions.prototype, "heatmap", void 0);
VizActions = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TabsSet: TabsSet_vue_1.default, Tab: Tab_vue_1.default, ConfigModal: ConfigModal_vue_1.default,
            Save: lucide_vue_next_1.Save, Download: lucide_vue_next_1.Download, MapPin: lucide_vue_next_1.MapPin, Maximize2: lucide_vue_next_1.Maximize2,
            GroupIcon: GroupIcon_vue_1.default, SubgroupIcon: SubgroupIcon_vue_1.default, SampleIcon: SampleIcon_vue_1.default, CellIcon: CellIcon_vue_1.default, ZoomIcon: ZoomIcon_vue_1.default
        }
    })
], VizActions);
exports.default = VizActions;
